import { Link } from "react-router-dom";
import PageWrapper from "../components/shared/PageWrapper";
import { ArrowIcon } from "../assets/icons";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

const HowToPlayPage = () => {

  useDocumentTitle("How to Play Chase the Ace | Rules Guide");

  return (
    <PageWrapper>
      <div className="item-list xxl-gap padding-top">
        <div className="item-list xl-gap">
          <div className="item-list">
            <Link to="/" className="icon-text secondary small">
              <ArrowIcon />
              Back to Home
            </Link>
            <h1 className="heading-large">How to Play Chase the Ace</h1>
          </div>
          <div className="item-list large-gap">
            <p className="body larger spaced">Everyone starts with three lives. Each round, you get one face-down card — Aces are low and Kings are high. The goal is simple: don’t have the lowest card when the round ends.</p>
            <p className="body larger spaced">Starting with the player left of the dealer, you choose to either keep your card or swap it with the next player to your left. They'll have to trade… unless they’ve got a King, which they can flip early to block you. When it’s the dealer’s turn, they can choose to cut the deck instead of staying with their card — but if they draw an Ace, they’re stuck with it!</p>
            <p className="body larger spaced">After the dealer plays, everyone flips their card. All players with the lowest card will lose a life. Be the last player left alive and you win!</p>
          </div>
        </div>
        <div className="item-list xl-gap">
          <h2 className="heading-small highlight">Advanced & Tips</h2>
          <div className="item-list large-gap">
            <p className="body larger spaced">If there is a tie in the final rounds that would make all remaining players lose the game, then the round won't count and the game will continue.</p>
            <p className="body larger spaced">In large groups the value of a "generally safe" card is lower. You're more likely to be safe with a 6 when there are 10 players alive. But get to the final 3 players, and now a 6 is much more risky to stay with.</p>
            <p className="body larger spaced">If you're late in the play order and a lot of quick swaps have been happening, then it's likely that there is a very low card in circulation. If this card gets stopped before reaching you -- either by a player who stays or a revealed King -- then you can feel safer staying with a lower card.</p>
            <p className="body larger spaced">The opposite of this is true as well. If everyone is staying before your turn, then they likely have higher cards, prompting you to reconsider your strategy.</p>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
};
export default HowToPlayPage;